import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/auth/authSlice";
import groceryListsReducer from "../store/groceryLists/groceryListsSlice";
import actowizReducer from "../store/actowiz/actowizSlice";
import plansReducer from "../store/plans/plansSlice";
import termsReducer from "../store/terms/termsSlice";
import faqReducer from "../store/faq/faqSlice";
import billingReducer from "../store/billing/billingSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    groceryLists: groceryListsReducer,
    actowiz: actowizReducer,
    plans: plansReducer,
    terms: termsReducer,
    faq: faqReducer,
    billing: billingReducer,
  },
});

